import { Component, Inject, Optional } from '@angular/core';
import {
  PermissionCheckerService,
  PershingTranslationService,
} from '@pershing/pershing-core';
@Component({
  selector: 'modern-quickquote',
  templateUrl: './modern-quick-quote.component.html',
})
export class ModernQuickQuoteComponent {
  showQuickQuote: boolean = true;
  showSearchPrompt: boolean = false;
  constructor(
    private authService: PermissionCheckerService,
    private translationService: PershingTranslationService,
    @Optional() @Inject('AppSettings') appSettings: any
  ) {
    this.translationService.addTranslationFolder(
      '@pershing/nxi-ng-mod',
      'node_modules/@pershing/nxi-ng-mod/lib'
    );
    if (appSettings.isLoggedIn) {
      this.showQuickQuote = !this.authService.isEntitled('EDELIVERY_ONLY');
    }
  }
  renderSearch(newItem: boolean) {
    this.showSearchPrompt = newItem;
  }
}
